export default __webpack_public_path__ + "static/media/successIcon.9d0bfb9a.svg";